import React from 'react';
import {
    Card, createStyles,
    CardActions,
    Theme, WithStyles, withStyles, CardMedia
} from "@material-ui/core";
import { GetApp as GetAppIcon } from '@material-ui/icons';

const styles = (theme: Theme) => createStyles({
    root: {
    },
    media: {
        paddingTop: '100%',
    },
});

interface Props extends WithStyles<typeof styles> {
    url: string;
};

class InnerCatCard extends React.Component<Props, {}> {
    render() {
        const { classes, url } = this.props;
        return (
            <Card className={classes.root}>
                <CardMedia
                    className={classes.media}
                    image={url}
                />
                <CardActions disableSpacing>
                    <a href={url} target="_blank" rel="noopener noreferrer" download>
                        <GetAppIcon />
                    </a>
                </CardActions>
            </Card>
        );
    }
}

export const CatCard = withStyles(styles)(InnerCatCard);